// src/domains/core/dashboard/hooks/useDashboardWidgets.ts

import { useEffect } from "react";

import { useDashboardStore } from "../store/dashboardStore";

/**
 * Hook für Dashboard-Widget Management
 *
 * @returns {object} Object with widget management functions and state
 *
 */
export function useDashboardWidgets() {
  const store = useDashboardStore();

  // Initialize on mount - only once
  useEffect(() => {
    if (!store.isInitialized) {
      store.initialize();
    }
  }, [store]);

  return {
    getWidget: store.getWidget,
    getWidgetsByCategory: store.getWidgetsByCategory,
    isInitialized: store.isInitialized,
    resetWidgets: store.resetWidgets,
    setWidgetSize: store.setWidgetSize,
    setWidgetVisible: store.setWidgetVisible,
    updateWidgetConfig: store.updateWidgetConfig,
    visibleWidgets: store.getVisibleWidgets(),
    widgets: store.widgets,
  };
}
